<template>
  <MenuList
    class="popup-menu-list"
    :items="items"
    :selected-item="selectedItem"
    :checkbox-style="checkboxStyle"
  />
</template>

<script>
import { MenuList } from '@/shared/ui/menu-list';

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
      default: () => {},
    },
    checkboxStyle: {
      type: String,
      default: 'inline',
      validator: (value) => ['inline', 'styled'].includes(value),
    },
  },
  components: { MenuList },
};
</script>

<style lang="scss" scoped>
.popup-menu-list {
  max-height: 300px;
  background-color: #ffffff;
  overflow-y: auto;
}
</style>
